import React, { useEffect, useState } from "react";
import dayjs from "dayjs";

import { Loadable } from "recoil";
import { alarmType } from "lib/store/common";

import { AlertIcon } from "@atsent/components";

import { channelType } from "lib/atsent";

import "./Alarm.scss";

export type AlarmProps = {
  cx?: string;
  data: Loadable<alarmType[]>;
  handleClickAllRead: () => void;
  handleClickRead: (id: number) => void;
};

export const Alarm: React.FC<AlarmProps> = ({
  cx = "",
  data,
  handleClickAllRead,
  handleClickRead,
}) => {
  const [isOpen, setOpen] = useState(false);
  const { state, contents } = data;
  const handleClickBg = (e: any) => {
    if (!e.target.className.toString().includes("al")) {
      setOpen(false);
      window.removeEventListener("click", handleClickBg);
    }
  };

  useEffect(() => {
    if (isOpen) {
      window.addEventListener("click", handleClickBg);
    }
    // eslint-disable-next-line
  }, [isOpen]);

  return (
    <div className={`Alarm ${cx} al`}>
      <AlertIcon
        cx={(isOpen ? "active" : "") + " al"}
        onClick={() => setOpen((_) => !_)}
        isNew={state === "hasValue" && contents.find((i: alarmType) => !i.read)}
      />
      {isOpen && (
        <div className={`al popup`}>
          <div className="al header">
            <span className={"al title"}>New</span>
            <span className={"al read"} onClick={handleClickAllRead}>
              모두읽음처리
            </span>
          </div>
          <div className="al body">
            {state === "hasValue" &&
              (contents.length > 0 ? (
                <ul className={"al"}>
                  {contents.map(
                    (
                      { content, created_at, read_at, type, id }: alarmType,
                      idx: number
                    ) => (
                      <li
                        key={`alarm-${idx}`}
                        onClick={() => {
                          if (!read_at) {
                            handleClickRead(id);
                          }
                        }}
                        className={"al " + (!read_at ? "new" : "")}
                      >
                        <div className="al text">
                          {type ? `[${channelType(type)}] ` : ""}
                          {content}
                        </div>
                        <span className={"al date"}>
                          {dayjs(created_at).format("MMM DD. YYYY")}
                        </span>
                      </li>
                    )
                  )}
                </ul>
              ) : (
                <div className={"al no-alarm"}>알람이 없습니다.</div>
              ))}
          </div>
        </div>
      )}
    </div>
  );
};
